<template>
  <div id="main">
    <div class="inner">
      <div class="row">
        <div class="col-8">
          <h1 class="align-center">Who We Are</h1>
          <!-- <p>
             is a directory for businesses owned
            by Asian Americans and Pacific Islanders. 
          </p> -->
          <p>
            Here at <b>AAPI Business Collective (AAPIBC)</b> we aim to support businesses belonging to Asian Americans and Pacific Islanders. AAPI business owners have historically faced a multitude of challenges in America. Founded during the height of the COVID pandemic, AAPIBC was created to connect your business with customers. Whether you're a multigenerational family-owned shop in the heart of Chinatown or an online-based start up, our goal is to provide a platform to share your business. We believe that making information open and freely available to all is the first step toward debunking misinformation and fostering a more just and equitable world.
          </p>
          <span class="image main"
            ><img src="../images/banner.jpg" alt="An AAPI owned store front"
          /></span>
          <!-- <p>
            While in recent decades, AAPI businesses have fared better, Covid-19
            only brought back many of the decades-old racist sentiments and
            xenophobia surrounding people of API-descent.
          </p>
          <p>
            Here, you can find businesses whose owners are AAPI. They are
            separated into categories. You will be able to read about the
            businesses and shop through their website. Keep in mind that, when
            you shop from an AAPI business, you are not only supporting the
            owner, you are supporting the workers as well.
          </p> -->
          <hr />
          <span class="image left"
            ><img
              src="../images/portrait_ada.jpg"
              alt="Portrait of co-founder Ada"
          /></span>
          <p>
            Ada is a designer and artist based in Brooklyn, NY. She believes
            that change in the world and in society starts with small actions of
            individuals. In her spare time, she likes to run, and hang out with
            her husband and two kids. Ada works on
            <a href>aapibusiness.co</a> graphic design and UI.
          </p>
          <!-- <p>
            <a
              href="https://www.linkedin.com/in/danielzhaocardenas/"
              class="icon brands style1 fa-linkedin"
              target="_blank"
              ><span class="label">Linkedin</span></a
            >
          </p> -->
          <span class="image right"
            ><img
              src="../images/portrait_daniel.jpg"
              alt="Portrait of co-founder Daniel"
          /></span>
          <p>
            Daniel is a polyglot and a Data Engineering Consultant. She is
            passionate about entrepreneurship and financial empowerment of
            women. When she's not coding or studying languages, she likes
            running, cycling and spending time with her husband and their three
            dogs. Daniel works on the
            <a href>aapibusiness.co</a> back and front end, database and
            deployment.
          </p>
          <!-- <p>
            <a
              href="https://www.linkedin.com/in/danielzhaocardenas/"
              class="icon brands style1 fa-linkedin"
              target="_blank"
              ><span class="label">Linkedin</span></a
            >
          </p> -->
          <p>
            <a
              href="https://www.danielatwork.com/"
              class="icon solid fa-link"
              target="_blank"
              ><span class="label">Website</span></a
            >
          </p>
          <hr />
          <p>
            The website <a href>aapibusiness.co</a> runs on a flask and mysql
            backend and a vue.js frontend.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",

  props: {},
};
</script>

<style scoped>
.row > .col-8 {
  margin: auto;
}
.row > * {
  padding: 0;
}
</style>
